import { Control, Controller } from "react-hook-form";
import { FormControl, InputLabel, styled } from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { GvSelectCustom } from "../../../styles/styledComponents";
import Loading from "../../Loading/Loading";
import React from "react";

const CustomExpandMoreIcon = styled(ExpandMoreIcon)(({ theme }) => ({
  color: theme.palette.gray.dark,
  fontSize: "1.25rem",
}));

interface ISelectControllerProps {
  id?: string;
  name: string;
  label?: string;
  control: Control<any>;
  options: { value: string | any, label: string }[];
  fullWidth?: boolean;
  onChanged?: (e: any) => void;
  defaultValue?: string | number;
  placeholder?: string;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
}

const GvSelectController = ({
  id,
  name,
  label,
  control,
  fullWidth = true,
  options = [],
  onChanged,
  defaultValue,
  placeholder,
  isLoading = false,
  disabled = false,
  className,
}: ISelectControllerProps) => {
  const fieldId = id || name;

  return (
    <>
      { label &&
        <InputLabel sx={{ marginBottom: "6px" }} htmlFor={fieldId} className={`${className}`}>{label}</InputLabel>
      }
      <FormControl fullWidth={fullWidth}>
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) =>
            <>
              <GvSelectCustom
                id={fieldId}
                error={!!fieldState.error}
                onChange={(e) => {
                  field.onChange(e);
                  onChanged && onChanged(e.target.value);
                }}
                value={field.value}
                defaultValue={defaultValue}
                disabled={isLoading || disabled}
                inputProps={{ IconComponent: CustomExpandMoreIcon }}
                className="border border-gray-3 rounded-sm"
              >
                <option aria-label="None" hidden>{isLoading ? "Loading..." : placeholder}</option>
                <option aria-label="None" disabled>{placeholder}</option>
                { options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                )) }
              </GvSelectCustom>
              { isLoading &&
                <Loading size={20} sx={{ position: "absolute", right: 24, top: 8 }} />
              }
            </>
          }
        />
      </FormControl>
    </>
  );
};

export default React.memo(GvSelectController);
